import { useEffect, useState } from 'react';
import { Tabs, TabHeader, TabPanel } from '@wk/components-react16';
import { useSelector } from 'react-redux';
import { RootState, store } from '../../store';
import { API_URL } from '../../config/constants';
import HttpService from '../../config/http.service';
import { Toast } from '../../services';
import ProjectTab from './ProjectTab';
import DimensionTab from './DimensionTab';
import TaxonomyTab from './TaxonomyTab';
import PromptTypeTab from './PromptTypeTab';
import CategoryScoreTypeTab from './CategoryScoreTypeTab';
import GuidedPromptQuestionTab from './GuidedPromptQuestionTab';
import { setAuthProject } from '../../store/authReducer';
import { Privilege } from '../../config/constants/privilege';
import GptAgentTab from './GptAgentTab';

const ProjectManagement = () => {
    const { authUser } = useSelector((state: RootState) => state.auth);
    const [activeTab, setActiveTab] = useState(0);
    const [isPrivilege, setIsPrivilege] = useState(false);



    const handleTabChange = (index: number) => {
        setActiveTab(index);
    };

    useEffect(() => {
        if (authUser && authUser.privileges) {
            setIsPrivilege(authUser.privileges.includes(Privilege[Privilege.EDIT_PROJECT_CONFIGURATION]) ||
                authUser.privileges.includes(Privilege[Privilege.DELETE_PROJECT_CONFIGURATION]));
        } else {
            setIsPrivilege(false);
        }
    }, [authUser]);

    return (
        <div>
            <div className='pt-10 pl-20 pr-20 pb-0'>
                <h4>Project Management</h4>
            </div>
            <div className='pl-5 pr-5 pb-20'>
                <Tabs mode="default" controlMode="controlled" selectedTab={activeTab}
                    onUserRequest={(event: any) => handleTabChange(event)}>
                    {isPrivilege ? (<>
                        <TabHeader slot="tabHeader">Project</TabHeader>
                        <TabPanel slot="tabPanel">
                            {activeTab === 0 && <ProjectTab />}
                        </TabPanel>
                    </>) : null}
                    <TabHeader slot="tabHeader">Dimensions</TabHeader>
                    <TabPanel slot="tabPanel">
                        {(isPrivilege ? activeTab === 1 : activeTab === 0) && <DimensionTab />}
                    </TabPanel>
                    <TabHeader slot="tabHeader">Taxonomy</TabHeader>
                    <TabPanel slot="tabPanel">
                        {(isPrivilege ? activeTab === 2 : activeTab === 1) && <TaxonomyTab />}
                    </TabPanel>
                    <TabHeader slot="tabHeader">Prompt Type</TabHeader>
                    <TabPanel slot="tabPanel">
                        {(isPrivilege ? activeTab === 3 : activeTab === 2) && <PromptTypeTab />}
                    </TabPanel>
                    <TabHeader slot="tabHeader">Category Score Type</TabHeader>
                    <TabPanel slot="tabPanel">
                        {(isPrivilege ? activeTab === 4 : activeTab === 3) && <CategoryScoreTypeTab />}
                    </TabPanel>
                    <TabHeader slot="tabHeader">Guided Prompt Question</TabHeader>
                    <TabPanel slot="tabPanel">
                        {(isPrivilege ? activeTab === 5 : activeTab === 4) && <GuidedPromptQuestionTab />}
                    </TabPanel>
                    <TabHeader slot="tabHeader">Fab Agent List</TabHeader>
                    <TabPanel slot="tabPanel">
                        {(isPrivilege ? activeTab === 6 : activeTab === 5) && <GptAgentTab />}
                    </TabPanel>
                </Tabs>
            </div>
        </div>
    );
};

export default ProjectManagement;
